module.exports = __webpack_public_path__ + "img/19.cd8812d1.png";